/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./PdfEditor.css";
import { StyleSheetManager } from "styled-components";
import IFrameContext from "./IFrameContext";
import style from "./style-min.css?inline";
import { nanoid } from "nanoid";

const styles = `
  <link rel="stylesheet" href="/src/components/pdf/style-min.css">
`;

const stylenew=`@import"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap";
@import"https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap";
@import"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap";
@import"https://fonts.googleapis.com/css2?family=Noto+Sans+Telugu&display=swap";

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box
}

#root {
    overflow: hidden;
    height: 100vh
}

body {
    position: relative
}

.pdf-sheet-wrap {
    display: flex;
    position: relative;
    /* height: 297mm */
}

.pdf-sheet {
    width: 210mm;
    /* min-height: 235mm; */
    background: #fff;
    box-shadow: 0 0 6px 2px #c2c1c1d1
}

.tbox {
    width: 260px;
    display: flex;
    cursor: default;
    border-radius: 2.62px;
    overflow: hidden;
    z-index: 0;
    padding-right: 6.26px;
    position: absolute;
    left: 0px;
    top: 0px
}

.tbox:focus-within {
    cursor: move
}

.tbox.focused {
    cursor: move
}

.tmover {
    width: 12px;
    visibility: hidden;
    background: #0078d4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff
}

.tmover.focused {
    visibility: visible
}

.tbody-cont {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 2.6px;
    border-top: 2.6px dashed transparent;
    border-right: 2.6px dashed transparent;
    border-bottom: 2.6px dashed transparent;
    min-width: 26px
}

.tbody-cont[data-focused=true] {
    border-top: 2.6px dashed #0078d4;
    border-right: 2.6px dashed #0078d4;
    border-bottom: 2.6px dashed #0078d4
}

.tbody {
    width: 100%;
    cursor: text;
    padding: 0 8.62px 0 0;
    z-index: 1;
    overflow: hidden;
    overflow-wrap: break-word
}

.tbody:focus-visible {
    outline: none
}

.tbody:empty:before {
    content: attr(data-placeholder);
    color: gray
}


.tbody::selection,
.tbody-cont>* ::selection {
    color: #000;
    background: #c7e7ff
}

.resizer {
    position: absolute;
    z-index: 2;
    right: -14px;
    font-size: 26px;
    border-radius: 26px;
    color: #0078d4;
    cursor: e-resize;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden
}

.resizer.focused {
    visibility: visible
}

.pdft-tbox-tooltip--cont {
    position: absolute;
    top: 0;
    display: none;
    background: #fff;
    height: 35px;
    width: fit-content;
    z-index: 11;
    border-radius: 2.6px;
    box-shadow: 0 0 8px 1px #c2c1c166, 2px 6px 8px 1px #c2c1c157;
    align-items: center;
    gap: 2.6px;
    padding: 2.6px
}

.tooltipbar--drop-select--main-cont {
    display: flex;
    flex-direction: column;
    border-radius: 2.6px;
    overflow: hidden
}

.tooltipbar--drop-select-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 52px;
    height: 30px;
    border-radius: 2.6px;
    background: none
}

.tooltipbar--drop-select-cont:hover {
    background: #ededed !important;
}

.tooltipbar--drop-select:hover,
.tooltipbar--drop-select[active="true"] {
    background: #eaeaea;
}

.tooltipbar--drop-select {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    height: 100%
}

.color-disp--rect {
    width: 16px;
    height: 5px;
    border: 1px solid #000
}

.color-picker--cont {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    position: fixed;
    top: 36px;
    border-radius: 2.6px;
    background: #fff;
    border: 1px solid #c0c0c0;
    overflow: hidden
}

.pdf-toolbar--cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2.6px 26px;
    border-bottom: 1px solid #bebebe;
    background: #ffffff;
    min-height: 48px;
    position: sticky;
    z-index: 1;
    top: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

@media (max-width: 425px) {
    .pdf-toolbar--cont {
        padding: 2.6px 10px;
    }
}

.flex-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 8px
}

.page-input-box--cont {
    text-align: center;
    height: 30px;
    width: 60px;
    border: 1px solid #bebebe;
    background: transparent;
    border-radius: 2.6px;
    transition: all 0.026s ease-in-out 0s;
}

.page-input-box--cont:hover,
.page-input-box--cont:focus {
    /* border: 1px solid #9e9e9e; */
    border: 1.26px solid #909090;
}

.page-input-box--cont:focus-visible {
    outline: none
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box !important;
}

.pdf-main--cont {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100vh;

}

#pdf-sheet-main--cont {
    background: #f3f3f3;
}

#pdf-sheet--cont {
    /* width: 100%;
    height: 100%;
    background: #e6e6e6;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    padding: 12px 0;
    overflow: auto;
    line-height: normal !important; */

    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    /* justify-content: center; */
    flex-grow: 1;
    padding: 8px;
    /* background: #f3f3f3; */
    width: fit-content;
}

.pdf--icon:hover {
    background: #eaeaea
}

.paper {
    /* background: #ffffff8f; */
    background: #ffffffe0;
    background: #ffffffc7;
    box-shadow: 0 0 8px 1px #c2c1c166,
        2px 6px 8px 1px #c2c1c157;
    border: 1px solid #bebebec7;
    border-radius: 3.26px;
    backdrop-filter: blur(26px);
    overflow: hidden;
}

.pdf-ctx-menu--cont {
    display: none;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 26;
    background: #ffffff8f;
    box-shadow: 0 0 8px 1px #c2c1c166, 2px 6px 8px 1px #c2c1c157;
    border: 1px solid #bebebec7;
    border-radius: 3.26px;
    overflow: hidden;
    backdrop-filter: blur(26px);
    transition: all .26s ease-in 0s
}

.pdf-ctx-menu--cont[dataopen=false] {
    display: none !important
}

.spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fafeff70;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2611
}

#latex--cont {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#latex-editor--cont {
    background: #f0f0f0;
    background: #d5eaff9c;
    background: #e9e9e98c;
    min-height: 126px;
    height: 100%;
    padding: 8px;
    overflow: auto;
}

.latex-code--cont {
    display: block;
    font-size: 1rem;
}

.latex-code--cont:empty::before {
    content: attr(placeholder);
    cursor: text;
    color: #626262;
}

.latex-code--cont:focus-visible {
    outline: none;
}

.latex-preview--cont {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    height: 126px;
    padding: 11px;
    font-size: 1.26rem;
    overflow: auto;
}

.latex-modal-backdrop {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 26;
    background: #d8d8d85e;
    display: flex;
    align-items: center;
    justify-content: center;
}

.latex-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 8px;
    gap: 8px;
}

.modal-cont {
    display: flex;
    flex-direction: column;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.modal-header--cont {
    display: flex;
    position: relative;
    align-items: center;
}

.modal-header-label {
    flex-grow: 1;
    height: 30px;
    padding-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
}

.modal-body--cont {
    flex-grow: 1;
    overflow: hidden;
    /* border: 1px solid; */
}

.modal-footer--cont {
    display: flex;
    /* padding: 8px; */
    /* border: 1px solid cadetblue; */
}


.small-screen-hide {
    display: block;
}

@media (max-width: 800px) {
    .small-screen-hide {
        display: none;
    }
}



.toolbarButton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    border: none;

    background: none;
    border-radius: 2px;
    cursor: pointer;
}

.toolbarButton::before {
    content: "";
    position: absolute;
    display: inline-block;
    width: 16px;
    height: 16px;
    mask-size: cover;
}

.toolbarButton[active=true] {
    background-color: var(--dark-active-color);
}

.toolbarButton:hover {
    background-color: var(--light-active-color);
}`

function IFrame(props) {
    console.log(props)
  const [ref, setRef] = useState();
  
  const container = ref?.contentWindow?.document?.body;
  console.log('cc',container)
  

  const context = useContext(IFrameContext);
  const [IFrameCtx, setIFrameCtx] = useState(context);
  const [ready, setReady] = useState(null);

//   function changedetect(){
//      props.changedetect();
//   }

  useEffect(() => {
    if (container) {
      const head = ref.contentWindow.document.head;
      head.innerHTML = `<style>${stylenew}</style>`;
      
      // container.style.boxSizing = "border-box";

      window.pdfDoc = ref.contentWindow.document;
      window.pdfWin = ref.contentWindow;
      window.pdfHead = head;
      
      
      console.log('wwww',window.pdfDoc)

      setIFrameCtx({
        window: ref.contentWindow,
        document: ref.contentWindow.document,
      });
      console.log(IFrameCtx,"iframe...")
      setReady(true);
      // props.target(ref.contentWindow);
    }
  }, [container]);

  // if (!ready) return;
  // window.addEventListener("DOMContentLoaded")
  //   window?.pdfWin?.addEventListener?.("DOMContentLoaded", (e) => setReady(true));

  return (
    <iframe
      ref={setRef}
      style={{
        // position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
        ...props.style,
      }}
      id={props.id || `iframe--${nanoid(3)}`}
      loading="lazy"
      allowFullScreen
      frameBorder={"0"}
    >
      {ready &&
        createPortal(
          <IFrameContext.Provider value={IFrameCtx}>
            <StyleSheetManager target={window?.pdfHead}>
              {props.children}
            </StyleSheetManager>
          </IFrameContext.Provider>,
          container

        )}
        {console.log(container)}
    </iframe>
  );
}

export default IFrame;
